<template>
  <ol>
    <li v-for="step in steps" :key="step.text" class="step">
      <div>{{ step.text }}</div>
      <pre v-if="step.snippet">{{ step.snippet }}</pre>
      <div class="img-container">
        <img v-if="step.image" :src="step.image" />
      </div>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.img-container {
  display: flex;
  justify-content: center;

  img {
    height: 600px;
    margin: 40px 0;
  }
}
.step {
  margin: 10px 0;
  font-size: 18px;
}

pre {
  margin-top: 10px;
  background-color: aliceblue;
  max-width: 50vw;
  border-radius: 5px;
}
</style>
